export type ProductImage = {
  file?: File;
  id: string;
  name: string;
  url: string;
};

export type ProductFormValues = {
  name: string;
  category: string;
  categoryLabel: string;
  subcategory: string;
  subcategoryLabel: string;
  description: string;
  mainImage: ProductImage | null;
  galleryImages: ProductImage[];
  keywords: string[];
};

export const defaultProductValues: ProductFormValues = {
  name: "",
  category: "",
  categoryLabel: "",
  subcategory: "",
  subcategoryLabel: "",
  description: "",
  mainImage: null,
  galleryImages: [],
  keywords: [],
};

export type SubmitIntent = "draft" | "publish";
export type ProductFormMode = "create" | "edit";
